import {
  LoginStatus,
  ParsedErrorResponse,
  ParsedLoginResponse,
} from 'api/auth-legacy/log-in.misc';
import { appInsights } from 'utils/telemetry/app-insights';
import { authLegacyApiService } from 'api/auth-legacy/auth.legacy.api.service';
import {
  clearRememberedLogin,
  saveRememberedLogin,
} from 'utils/remembered-login';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const logIn = createAsyncThunk<
  ParsedLoginResponse,
  {
    email: string;
    password: string;
    rememberMe?: boolean;
    rememberMeDays?: number;
    skipRememberedLoginSave?: boolean;
  },
  { rejectValue: ParsedErrorResponse }
>(
  'auth/log-in',
  async (
    { email, password, rememberMe, rememberMeDays, skipRememberedLoginSave },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await authLegacyApiService.logInUser(email, password);
      const res = JSON.parse(data.d) as ParsedLoginResponse;
      if (res._Status === LoginStatus.Error) {
        if (rememberMe) {
          clearRememberedLogin();
        }
        return rejectWithValue(res as ParsedErrorResponse);
      }

      if (rememberMe) {
        if (!skipRememberedLoginSave) {
          await saveRememberedLogin({
            id: email,
            token: password,
            days: rememberMeDays || 90,
          });
        }
      } else {
        clearRememberedLogin();
      }
      appInsights.trackEvent({ name: 'Logged in' });
      return res;
    } catch (e) {
      if (rememberMe) {
        clearRememberedLogin();
      }
      return rejectWithValue({
        _Status: LoginStatus.Error,
        _Data: 'Unexpected login error',
      });
    }
  },
);
